<ew-mat-dialog-custom>
  <ew-mat-stepper-custom>
    <ew-mat-stepper-custom-step>
      <h1 class="mb-3">Please choose the currency to add money</h1>
      <ngu-carousel
        #myCarousel
        [inputs]="carouselConfig"
        [dataSource]="currencies"
        (carouselLoad)="carouselTileLoad($event)">
        <div
          *nguCarouselDef="let item; let j = index"
          class="item flex justify-center items-center"
          [class.items-end]="j == myCarousel.activePoint"
          [class.items-center]="j == myCarousel.activePoint + 1">
          <ew-currency-money
            class="w-60"
            [class.active]="j == myCarousel.activePoint + 1"
            [item]="item"
            (click)="myCarousel.moveTo(j - 1)"></ew-currency-money>
        </div>
        <button NguCarouselNext class="prev-next rightRs">
          <mat-icon class="fa-regular fa-chevron-right"></mat-icon>
        </button>
        <button NguCarouselPrev class="prev-next leftRs">
          <mat-icon class="fa-regular fa-chevron-left"></mat-icon>
        </button>
        <!-- <ul class="myPoint" NguCarouselPoint>
          		<li *ngFor="let j of myCarousel.pointNumbers; let j = index" [class.active]="j==myCarousel.activePoint" (click)="myCarousel.moveTo(j)"></li>
          	</ul> -->
      </ngu-carousel>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <h1 class="mb-3">Please select the prefered payment to add money</h1>
      <ew-payment-method-list></ew-payment-method-list>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <h1 class="mb-3">Please, select the amount to transfer</h1>
      <div class="p-20 xs:px-0">
        <ew-price-information [price]="315074.15"></ew-price-information>
      </div>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <h1 class="mb-3">Flywire is adding money to your wallet</h1>
      <div class="p-20 xs:px-0">
        <ew-price-information
          [provider]="provider"
          [progress]="true"
          [fontsSizePrice]="'text-5xl'"
          [price]="315074.15"></ew-price-information>

        <div class="w-full text-center my-10">
          <button
            class="rounded-lg xs:w-full w-80"
            mat-flat-button
            color="primary">
            Download proof of payment
          </button>
        </div>
      </div>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <img class="w-3/5 m-auto fly" src="assets/fly.svg" alt="" />
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>
